import { api } from '../config/api'
import { CATEGORY } from './actionTypes'

export const getCategory = () => (dispatch, getState) => {
  const { lang } = getState()
  if (!getState().category.length) {
    dispatch({ type: CATEGORY.REQUEST })
    return (
      fetch(api.category)
      .then(res => res.json())
      .then((res) => {
        dispatch({ type: CATEGORY.SUCCESS, data: res })
      })
      .catch((err) => {
        dispatch({ type: CATEGORY.FAILURE, error: err })
      })
    )
  }
}


// WEBPACK FOOTER //
// ./src/actions/getCategory.js